import React from "react";
import styled from "styled-components";

interface BlankProps {
  blankHeight: number;
  marginHeight?: number;
}

export default function Blank({ blankHeight, marginHeight }: BlankProps) {
  return (
    <BlankContainer blankHeight={blankHeight} marginHeight={marginHeight} />
  );
}

const BlankContainer = styled.div<BlankProps>`
  width: 100%;
  height: ${({ blankHeight }) => blankHeight}px;
  margin-top: ${({ marginHeight }) => marginHeight ?? 0}px;
`;
